<app-full-page-message *ngIf="isNoAccess"></app-full-page-message>
<div *ngIf="printContent && elementIds" id="rv-print-content" style="width: 100%;">
    <div style="text-align: right;">
        <button class="button_icon button_icon_color close-btn action-btn" *ngIf="isPreview"
            title="{{localService.languageContent.common.close}}" (click)="OnClosePopup()">close</button>
        &nbsp;
        <button class="button_icon action-btn" style="color: darkgrey;" (click)="onPrintFinal()">print</button>
        &nbsp;
        <button class="button_icon button_icon_color action-btn" (click)="onPrint()">print</button>
    </div>
    <div style="display: flex; justify-content: center;">
        <div id="{{elementIds.receipt_iframe_wrapper}}"
            style="width:100%; padding: 10px;border-style: solid;border-width: 1px;border-color: lightgrey;background-color: white;">
            <iframe id="{{elementIds.receipt_iframe}}"></iframe>
        </div>
    </div>
</div>
<div style="position: fixed; top: 0;left:0; text-align: center; background-color: black; width: 100%; height: 100%; margin: 0px; padding: 0px; opacity: 0.5; z-index: 100;margin-left:-12px;"
    *ngIf="isPrint && isOldPrintEnable">
    <span>{{localService.languageContent.common.close_print}}</span>
    <br />
    <button class="button_icon button_icon_color"
        style="transform: rotate(45deg);font-size: 50px !important;  margin-top: 50px !important;  color: red !important;"
        title="{{localService.languageContent.common.close}}" (click)="isPrint = false;">add_circle_outline</button>
</div>
<div style="display:none;">
    <input type="button" class="on_language_changed" (click)="onLoad()" />
</div>